import { NgModule } from '@angular/core';
import { MatCurrencyFormatDirective } from './mat-currency-format.directive';



@NgModule({
  declarations: [ MatCurrencyFormatDirective],
  imports: [
  ],
  exports: [MatCurrencyFormatDirective ]
})
export class MatCurrencyFormatModule { }
